import { useEffect } from "react";
import AppAPI from "../api";

export default function useEntities() {
  const [getTableData] = AppAPI.useLazyGetTableDataQuery()
  const [getCountries] = AppAPI.useLazyGetCountriesQuery()
  const [getActivities] = AppAPI.useLazyGetActivitiesQuery()

  useEffect(() => {
    getTableData({})
    getCountries(null)
    getActivities(null)
  }, [getActivities, getCountries, getTableData])
}
